import { api } from '@/shared/axios-client';

export interface JenkinsJob {
  name: string;
  fullName: string;
  url?: string;
  color?: string;
  _class?: string;
  isFolder?: boolean;
}

export interface JenkinsAuthBody {
  baseUrl: string;
  username: string;
  apiToken: string;
}

export interface JenkinsServiceResponse<T> {
  success: boolean;
  statusCode: number;
  message: string;
  data?: T;
}

export const fetchJenkinsJobs = (
  body: JenkinsAuthBody & { recursive?: boolean },
): Promise<JenkinsServiceResponse<{ jobs: JenkinsJob[] }>> =>
  api.post('/api/scm/jenkins/jobs', {
    baseUrl: body.baseUrl.trim(),
    username: body.username.trim(),
    apiToken: body.apiToken.trim(),
    recursive: body.recursive ?? true,
  });

export const fetchJenkinsBuilds = (
  body: JenkinsAuthBody & { jobName: string; limit?: number },
): Promise<
  JenkinsServiceResponse<{
    jobName: string;
    jobUrl?: string;
    lastBuild?: { number: number; result?: string } | null;
    lastSuccessfulBuild?: { number: number; result?: string } | null;
    builds: Array<{ number: number; result?: string; timestamp?: number }>;
  }>
> =>
  api.post('/api/scm/jenkins/builds', {
    baseUrl: body.baseUrl.trim(),
    username: body.username.trim(),
    apiToken: body.apiToken.trim(),
    jobName: body.jobName.trim(),
    limit: body.limit ?? 25,
  });
